import React from "react";

function TrainingProjects() {
  const projects = [
    {
      title: "Java DSA Training",
      trainer: "Rahul Sharma",
      duration: "15 Days",
      location: "Noida",
      status: "ONGOING",
    },
    {
      title: "Python Full Stack",
      trainer: "Amit Kumar",
      duration: "30 Days",
      location: "Delhi",
      status: "UPCOMING",
    },
  ];

  return (
    <div className="page">
      <h1>Training Projects</h1>
      <p>Manage your training projects.</p>

      <div className="grid">
        {projects.map((project, index) => (
          <div className="card" key={index}>
            <h2>{project.title}</h2>

            <p>
              <b>Trainer:</b> {project.trainer}
            </p>

            <p>
              <b>Duration:</b> {project.duration}
            </p>

            <p>
              <b>Location:</b> {project.location}
            </p>

            <span className="status">
              {project.status}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .grid {
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:20px;
          margin-top:25px;
        }

        .card {
          background:white;
          padding:22px;
          border-radius:12px;
          box-shadow:0 4px 15px rgba(0,0,0,.06);
        }

        .card h2 {
          font-size:19px;
        }

        .card p {
          color:#64748b;
        }

        .status {
          display:inline-block;
          margin-top:10px;
          padding:6px 12px;
          border-radius:20px;
          background:#dbeafe;
          color:#1d4ed8;
          font-size:11px;
          font-weight:bold;
        }

        @media(max-width:900px) {
          .grid {
            grid-template-columns:1fr 1fr;
          }
        }

        @media(max-width:600px) {
          .grid {
            grid-template-columns:1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default TrainingProjects;